import { render, staticRenderFns } from "./CKycPersonalDetails.vue?vue&type=template&id=c1ce8476&scoped=true&"
import script from "./CKycPersonalDetails.vue?vue&type=script&lang=js&"
export * from "./CKycPersonalDetails.vue?vue&type=script&lang=js&"
import style0 from "./CKycPersonalDetails.vue?vue&type=style&index=0&id=c1ce8476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ce8476",
  null
  
)

export default component.exports